export class EncoreConfiguration{
    public isEnabled: boolean;
    public jsUrl : string;
    public cssUrl :string;
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/configuration/encore-configuration.model.ts